import React from 'react';
import clsx from 'clsx';
import './Card.scss';

export interface ICard {
  children?: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
}

const BASE_CLASS = 'ui-kit-card';

const Card = ({ children, className: externalClassName, onClick, ...rest }: ICard) => {
  const role = onClick ? 'button' : 'article';
  const className = clsx(BASE_CLASS, `${BASE_CLASS}-role-${role}`, externalClassName);
  return (
    <div className={className} {...(onClick ? { onClick, role } : {})} {...rest}>
      {children}
    </div>
  );
};

export default Card;
